<template>
  <div class=" mb-3 pb-3 border-bottom">
    <UserData
      :user-data="user"
      :fields-to-show="requiredData"
      @changes="updateUserData"
    />

    <Errors :errors="errors" />
    <b-link
      class="btn btn_1 full-width mt-3"
      href="#"
      :disabled="!allFieldsCompleted"
      @click="saveUserData"
    >
      <span>{{ $t('lang.bookings.continue_to_payment') }}
        <i class="icon-angle-double-right" />
      </span>
    </b-link>
  </div>
</template>
<script>
import UserData from '@/components/User/UserData.vue';
import { API, errorResponse } from '@/api/api';
import Errors from '@/components/Alerts/Errors.vue';

const UserAPI = API.get('user');

export default {
  name: 'BookingExtraData',
  components: { Errors, UserData },

  props: {
    requiredData: {
      type: Array,
      required: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      requiredDataValues: {},
      errors: {},
    };
  },
  computed: {
    allFieldsCompleted() {
      return Object.values(this.requiredDataValues).every(
        (val) => val !== null && val !== undefined && val !== '',
      );
    },
  },

  created() {
    // Preload required data values with the user data existing
    this.requiredData.forEach((field) => {
      this.$set(this.requiredDataValues, field, this.user[field] || null);
    });
    this.$set(this.requiredDataValues, 'id', this.user.id);
  },

  methods: {
    updateUserData(data) {
      const clave = Object.keys(data)[0];
      const newValue = Object.values(data)[0];
      this.requiredDataValues[clave] = newValue;
    },

    async saveUserData() {
      this.errors = {};

      if (this.allFieldsCompleted) {
        try {
          await UserAPI.setUserData(this.requiredDataValues);

          this.$emit('extraDataCompleted');
        } catch (error) {
          this.errors = errorResponse(error);
        }
      }
    },
  },
};
</script>
<style scoped>

</style>
